import videoSrc from "/videos/hero-section.mp4";
import { motion } from "motion/react";

export default function AboutFlowstep() {
  return (
    <section className="w-full overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-[1600px] px-4 md:px-8 lg:px-16">
        <div className="grid items-center gap-8 md:gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left side - Text content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-4 md:space-y-6"
          >
            <h2
              className="leading-[1.1] tracking-tight text-white"
              style={{ fontSize: "var(--text-section)", fontWeight: "600" }}
            >
              Bring your ideas to life, instantly
            </h2>
            {/* Mobile: 3 paragraphs for readability */}
            <div
              className="block max-w-3xl space-y-4 leading-relaxed text-gray-300 md:hidden"
              style={{ fontSize: "var(--text-lead)" }}
            >
              <p>
                The best ideas aren't always the loudest—they're the ones people
                understand.
              </p>
              <p>Flowstep turns your thoughts into editable UI in seconds.</p>
              <p>
                We help teams learn, align, and ship faster. This is our first
                step toward building the most loved design tool on the planet.
              </p>
            </div>

            {/* Desktop: Single paragraph */}
            <p
              className="hidden max-w-3xl leading-relaxed text-gray-300 md:block"
              style={{ fontSize: "var(--text-lead)" }}
            >
              The best ideas aren't always the loudest—they're the ones people
              understand. Flowstep turns your thoughts into editable UI in
              seconds. We help teams learn, align, and ship faster. This is our
              first step toward building the most loved design tool on the
              planet.
            </p>
          </motion.div>

          {/* Right side - Image placeholder */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <video
              src={videoSrc}
              loop
              preload="auto"
              muted
              playsInline
              autoPlay
              className="h-full w-full rounded-3xl object-cover object-center shadow-2xl"
            ></video>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
